import { formatArticleDate, formatArticleMonth } from '@/entities/feed-article';
import type { FeedInfo } from '@/entities/feed-article';
import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

export function mapFeedInfoToArticle(item: FeedInfo): MonthlyRecapsArticle {
  return {
    month: formatArticleMonth(item.transactionTime),
    region: item.values.CTALabel || item.symbol.KeyValue,
    headline: item.values.Title,
    description: item.values.Content.replaceAll(/(^")|("$)/g, ''),
    date: formatArticleDate(item.transactionTime),
    file: item.values.CTAValue
  };
}
